<template>
  <div class="modal-card">
    <div class="modal-card-body" style="width:645px; height:500px;" v-if="loading">
      <b-loading :is-full-page="false" :active="loading"></b-loading>
    </div>

    <!--  <div v-else-if="policy.errors" class="modal-card-body">-->
    <!--    <b-message  type="is-danger" aria-close-label="Close message">-->
    <!--      Rate / cancellation details unavailable-->
    <!--    </b-message>-->
    <!--  </div>-->

    <div v-else class="card" style="width:645px">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Rate / Cancellation Details</p>
          <button
              type="button"
              class="delete"
              @click="$emit('close')"/>
        </header>

        <section class="modal-card-body">
          <p class="is-size-4 mb-4" v-if="policy.data.HotelName">
            {{policy.data.HotelName}}
          </p>
          <div class="columns" v-if="!policy.errors">
            <div class="column">
              <div class="container">
                <div v-if="policy.data.cancelPenalties" class="mb-3">
                  <h3 class="is-size-5">Cancellation Policy</h3>
                  <div v-for="(cancelPenalty, index) in policy.data.cancelPenalties" :key="index">
                    <b-tag v-if="cancelPenalty.nonrefundable" type="is-danger is-light">Non-refundable</b-tag>
                    <CancelPenalty :cancelPenalty="cancelPenalty" ></CancelPenalty>
                  </div>
                </div>
                <div v-else-if="cancelPolicy" class="mb-3">
                  <h3 class="is-size-5">Cancel Policy</h3>
                  <li v-for=" item in cancelPolicy" :key="item" class="is-size-7">
                    {{item._}}
                  </li>
                </div>
              </div>
              <div class="container">
                <div v-if="policy.data.features">
                  <h3 class="is-size-5">Features</h3>
                  <div class="content">
                    <ul>
                      <li class="is-size-7" v-for="item in policy.data.features" :key="item">
                        {{ item}}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="container">
                <div v-if="rateDescription">
                  <h3 class="is-size-5">Details</h3>


                  <!-- <li class="is-size-7" v-for="item in rateDescription" :key="item._">
                    {{ item._}}
                  </li> -->

                  <span class="is-size-7" v-for="item in rateDescription" :key="item._">
                  {{ item._}}
                </span>



                </div>
              </div>
              <div v-if="hotelDates.length > 0" class="mb-5 mt-3">
                <h3 class="is-size-5 mb-2">Daily Price Breakdown</h3>

                <div class="priceBreakdown">
                  <div class="" style="max-height: 120px; overflow: auto;">
                    <ul class="is-marginless mb-2">
                      <li class="" v-for="date in hotelDates" :key="`date_${date.id}`">
                  <span class="is-size-7 has-text-right" style="display:inline-block; width: 130px;">
                    {{ $moment(date.startDate).format('ddd, MMM D') }}
                  </span>
                        <span class="is-size-7 is-inline-block has-text-right" style="width: 60px;">{{ date.title }}</span>
                      </li>
                    </ul>
                  </div>
                  <hr class="is-marginless is-paddingless">
                  <ul class="is-marginless mb-2" style="list-style: none !important;">
                    <li>
                <span class="is-size-7 has-text-right" style="display:inline-block; width: 130px;">
                  <strong>Subtotal</strong>
                </span>
                      <span class="is-size-7 is-inline-block has-text-right" style="width: 60px;">
                  <strong>${{ this.calculatedSubtotal.toFixed(2) }}</strong>
                </span>
                    </li>

                    <li>
                <span class="is-size-7 has-text-right" style="display:inline-block; width: 130px;">
                  <strong>Tax</strong>
                  </span>
                      <span class="is-size-7 is-inline-block has-text-right" style="width: 60px;"><strong>${{ calculatedTax.toFixed(2) }}</strong></span>
                    </li>
                    <hr class="is-marginless is-paddingless" style="height:4px">
                    <li>
                <span class="is-size-7 has-text-right" style="display:inline-block; width: 130px;">
                  <strong>Estimated total</strong>
                  </span>

                      <span class="is-size-7 is-inline-block has-text-right has-text-weight-bold" style="width: 60px;">${{ calculatedTotal.toFixed(2) }}</span>
                    </li>
                  </ul>
                </div>

              </div>
            </div>
          </div>
          <div v-if="!policy.errors">
            <div v-if="policy.data.AdditionalDetail">
              <p class="is-size-7" v-for="item in policy.data.AdditionalDetail" :key="item._">
                {{item._}}
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>


  </div>
</template>

<script>
    import CancelPenalty from "./CancelPenalty";
    import bookingMixin from "@/mixins/bookingMixin";

    export default {
      name: 'EnhancedPricingModal',
      mixins: [bookingMixin],
      components: {
        CancelPenalty,
      },
      props: {
        sol: Object,
        session: String
      },
      data: function () {
          return {
            isOpen: 0,
            policy: null,
            loading: true
        }
      },
      computed: {
      cancelPolicy() {
        try {
          if (Array.isArray(this.policy.data.cancelPenalty.Description) ){
            return this.policy.data.cancelPenalty.Description
          }
          else if (this.policy.data.cancelPenalty.Description == null){
            return null
          }
          else {
            return [this.policy.data.cancelPenalty.Description]
          }
        }
        catch {
          return null
        }


      },
      rateDescription() {
        try {
          if (Array.isArray(this.policy.data.RatePlanDescription.Text) ){
            return this.policy.data.RatePlanDescription.Text
          }
          else if (this.policy.data.RatePlanDescription.Text == null){
            return null
          }
          else {
            return [this.policy.data.RatePlanDescription.Text]
          }
        }
        catch {
          return null
        }


      },
        hotelDates(){
          let dates = this.sol.enhancedPricing.dailyRates;
          let hDates = [];
          for(let hDate of dates){
            let dateObj = {
              id: hDate.date,
              startDate: hDate.date,
              endDate: hDate.date,
              title: `$${ hDate.amount.toFixed(2) }`,
            }

            hDates.push(dateObj);
          }

          return hDates;
        },
        calculatedSubtotal(){
          let subtotal = 0;

          if (this.sol.originalPricing.AmountBeforeTax) {
            return Number(this.sol.originalPricing.AmountBeforeTax)
          }

          let dates = this.sol.enhancedPricing.dailyRates;
          for(let hDate of dates){
            subtotal = subtotal + hDate.amount
          }

          return subtotal
        },
        calculatedTotal() {
          return Number(this.sol.originalPricing.AmountAfterTax)
        },
        calculatedTax() {
          // let tax = Number(this.sol.originalPricing.AmountAfterTax) - Number(this.sol.originalPricing.AmountBeforeTax)
          let tax = this.calculatedTotal - this.calculatedSubtotal;

          return tax;
        },
    },
      methods: {
        async getRules() {
          // console.log(this.sol)

          var raw = {
            "stateful":true,
            "sessionKey":this.session,
            "normalizeResponse":true,
            "hotelCode":this.sol.hotelCode,
            "checkInDate":this.sol.startDate,
            "checkOutDate":this.sol.endDate,
            "roomCount":1,
            "guestCount":1,
            "roomTypeCode":this.sol.enhancedPricing.roomTypeCode,
            "bookingCode":this.sol.enhancedPricing.bookingCode,
            "ratePlanCode":this.sol.enhancedPricing.ratePlanCode,
            "ratePlanType":null,
            "mealPlanCode":null
          }

          // console.log(JSON.stringify(raw))

          try {
            this.$app.huddleLabsServerCall('amadeus/hotel/enhanced-pricing', raw)
              .then(result => {this.updateKey(result)})
          }
          catch {
            this.loading = false
            this.policy.error = true
          }

        },
        async updateKey(result){
          if (result.errors && result.errors.length > 0){
            if (result.errors[0].code == 'SCM'){
              var body = {
                "stateful": true,
                "sessionKey": this.session,
                "requestedCurrency": "USD",
                "normalizeResponse": true,
                "travelerContactId": this.$store.getters['travellersAndTrips/getCurrentTravellerProfile'].id,
                "travelPolicyId": this.$store.getters['travellersAndTrips/getCurrentTravellerProfile'].travelPolicyId,
                "hotelCode": this.sol.hotelCode,
                "checkInDate":this.sol.startDate,
                "checkOutDate":this.sol.endDate,
                "roomCount": 1,
                "guestCount": 1,
                "ratePlanCodes": [

                ]
              }

              this.$app.huddleLabsServerCall('amadeus/hotel/live-search', body)
              .then(result => {this.getRules()})
            }
            else{
              this.policy = result;
              this.loading = false;
              // console.log(result.error);
            }
          }
          else{
            this.policy = result;
            this.loading = false;
            // console.log(result.error);
          }


        },
      },
      mounted () {
        this.getRules()
      },
  }
</script>

<style scoped>

</style>
